import {createBotWorker} from './workerClient';
export class WorkerBridge {
  constructor(){this.worker=createBotWorker();this.jobs=new Map();this.serial=0;this.closed=false;
    this.worker.onmessage=event=>{const job=this.jobs.get(event.data.id);if(!job)return;clearTimeout(job.timer);this.jobs.delete(event.data.id);event.data.error?job.reject(Error(event.data.error)):job.resolve(event.data);};
    this.worker.onerror=()=>this.close(Error('Bilgisayar yanıt veremedi. Kaydedilen oyunu yeniden aç.'));
  }
  call(type,data={}) {
    return new Promise((resolve,reject)=>{if(this.closed){reject(Error('Bilgisayar hazır değil.'));return;}const id=++this.serial;
      const timer=setTimeout(()=>this.close(Error('Bilgisayar yanıt vermedi. Kaydın korunuyor; yeniden dene.')),20000);
      this.jobs.set(id,{resolve,reject,timer});this.worker.postMessage({id,type,...data});
    });
  }
  close(error=Error('Oyun kapatıldı.')){this.closed=true;this.worker.terminate();for(const job of this.jobs.values()){clearTimeout(job.timer);job.reject(error);}this.jobs.clear();}
}
